import React from 'react'
import moment from 'moment'
import { CalendarEvent } from './types'
import { EventProps } from 'react-big-calendar'

export const AppointmentEventCell: React.FC<EventProps<CalendarEvent>> = ({ event }) => {
  const durationMinutes = moment(event.end).diff(moment(event.start), 'minutes')
  const showTime = !event.allDay && durationMinutes >= 30
  const timeRange = showTime ? formatTimeRange(event.start, event.end) : null

  return (
    <div className="appointment-event-cell">
      <div className="appointment-event-cell__title">{event.title}</div>
      {timeRange && <div className="appointment-event-cell__time">{timeRange}</div>}
    </div>
  )
}

function formatTimeRange(start: Date, end: Date): string {
  const startMoment = moment(start)
  const endMoment = moment(end)
  const samePeriod = startMoment.format('a') === endMoment.format('a')

  const startFormatted = formatTime(start, true, !samePeriod)
  const endFormatted = formatTime(end, true, true)

  return `${startFormatted}–${endFormatted}`
}

function formatTime(date: Date, includeMinutes: boolean, includePeriod: boolean): string {
  const m = moment(date)
  const hour = m.format('h')
  const minute = m.minute()
  const period = includePeriod ? m.format('a') : ''

  if (!includeMinutes || minute === 0) {
    return `${hour}${period}`
  }

  return `${hour}:${minute.toString().padStart(2, '0')}${period}`
}
